<template>
  <div class="event-wrapper">
    <div class="close-button" @click="goBack">
      <img src="@/assets/icons/cancel-24px.png" alt="close" />
    </div>
    <div id="event-data" v-if="eventData">
      <div class="event-header">
        <div class="cover-wrapper">
          <div class="cover" v-if="coverImage">
            <img class="cover-img" :src="imageUrl(coverImage)" alt="" />
            <img
              v-if="eventData.logo || eventData.poi?.logo"
              class="cover-logo"
              :src="imageUrl(eventData.logo || eventData.poi.logo)"
              alt="logo"
            />
          </div>

          <!-- TITLU -->
          <div class="event-name">
            {{ eventData.title || eventData.name }}
          </div>
        </div>

        <div class="event-infos">
          <!-- TITLU -->
          <!-- <div class="event-name">
            {{ eventData.name || eventData.title }}
          </div> -->
          <!-- DATA + ORA -->
          <div class="event-date">
            <img src="@/assets/icons/calendar.png" class="event-small-icon" alt="" />

            {{ formatDate(eventData.date_from) }} - {{ formatDate(eventData.date_to) }}

            <template v-if="eventData.opening_hour || eventData.hour_from || eventData.time_from">
              ⏰ {{ formatTime(eventData.opening_hour || eventData.hour_from || eventData.time_from) }}
            </template>

            <template v-if="eventData.closing_hour || eventData.hour_to || eventData.time_to">
              - {{ formatTime(eventData.closing_hour || eventData.hour_to || eventData.time_to) }}
            </template>
          </div>
          <!-- ADRESA -->
          <div class="event-detail-row" v-if="(eventData.poi_name || eventData.poi?.name) && addressLines.length">
            <div>
              <div class="event-row-text">
                <span class="event-poi-name">
                  {{ eventData.poi_name || eventData.poi?.name }}
                </span>

                <img src="@/assets/icons/marker.png" class="event-row-icon" alt="" />

                {{ addressLines[0] }}

                <template v-if="addressLines[1]">
                  {{ addressLines[1] }}
                </template>
              </div>
            </div>
          </div>
          <!-- WEBSITE -->
          <div class="event-detail-row" v-if="websiteUrl">
            <div class="event-row-text">
              <img src="@/assets/icons/website.png" class="event-row-icon" alt="" />

              <a :href="websiteUrl" target="_blank">
                {{ websiteUrl.replace(/^https?:\/\//, "") }}
              </a>
            </div>
          </div>

          <!-- INFO -->
          <div class="event-detail-row" v-if="eventData.description">
            <div>
              <div class="event-row-label">
                <img src="@/assets/icons/info.png" class="event-row-icon" alt="" />
                {{ $t("events.information") }}
              </div>
              <div class="event-description" v-html="eventData.description"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import M2wApi from "@/services/m2w_api";

export default {
  name: "EventDetails",

  data() {
    return {
      hostAddress: M2wApi.host_address,
      eventData: null,
      showRoutingMap: false,
      eventStop: null,
      initialLatFromEvent: null,
      initialLngFromEvent: null
    };
  },

  computed: {
    coverImage() {
      return this.eventData?.cover_image || this.eventData?.cover || this.eventData?.poi?.cover || null;
    },
    websiteUrl() {
      const url =
        this.eventData?.website ||
        this.eventData?.contact?.website ||
        this.eventData?.poi?.website ||
        this.eventData?.poi?.contact?.website ||
        "";

      if (!url) return "";

      return url.startsWith("http") ? url : `https://${url}`;
    },
    addressLines() {
      return this.eventData?.poi?.address || [];
    }
  },
  watch: {
    "$route.params.id": {
      async handler(newId, oldId) {
        if (!newId || newId === oldId) return;

        console.log("[EventDetails] event changed:", {
          oldId,
          newId,
          route: this.$route.fullPath
        });

        await this.fetchFromApi();
      }
    },
    "$i18n.locale": async function() {
      await this.fetchFromApi();
    }
  },

  async mounted() {
    await this.fetchFromApi();
  },

  methods: {
    async fetchFromApi() {
      const id = this.$route.params.id;
      const poiId = this.$route.query.poi_id;
      const parent = this.$route.query.parent;

      this.eventData = await M2wApi.get_single_event(id, this.$i18n.locale, poiId, parent);

      console.log("EVENT DATA:", this.eventData);
    },

    imageUrl(path) {
      if (!path) return "";
      if (path.startsWith("http")) return path;
      return this.hostAddress + path;
    },

    formatDate(date) {
      if (!date) return "";

      return new Date(date).toLocaleDateString(this.$i18n?.locale || "ro", {
        day: "2-digit",
        month: "short",
        year: "numeric"
      });
    },
    formatTime(time) {
      if (!time) return "";

      return String(time).slice(0, 5);
    },
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>
